import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';

import { AppComponent } from './app.component';
import { BnNgIdleService } from 'bn-ng-idle';
import { AppRoutingModule } from './app-routing.module';
import { FooterComponent } from './footer/footer.component';
import { TableModule } from 'primeng/table';
import { PaginatorModule } from 'primeng/paginator';
import { CalendarModule } from 'primeng/calendar';
import { PanelModule } from 'primeng/panel';
import { CustomService } from './shared/services/custom.service';
import { ReportDiscrepancyComponent } from './report-discrepancy/report-discrepancy.component';
import { SearchDiscrepancyComponent } from './search-discrepancy/search-discrepancy.component';
import { DetailsDiscrepancyComponent } from './details-discrepancy/details-discrepancy.component';
import { UnauthorizedComponent } from './unauthorized/unauthorized.component';
import { TokenInterceptor } from './token.interceptor';
import { AuthGuard } from './auth.guard';
import { AuthService } from './auth.service';
import { RedirectComponent } from './redirect/redirect.component';
import { ProgressSpinnerModule } from 'primeng/progressspinner';
import { DatePipe } from '@angular/common';

@NgModule({
  declarations: [
    AppComponent,
    FooterComponent,
    ReportDiscrepancyComponent,
    SearchDiscrepancyComponent,
    DetailsDiscrepancyComponent,
    UnauthorizedComponent,
    RedirectComponent
  ],
  imports: [
    BrowserModule,
    FormsModule,
    ReactiveFormsModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    HttpClientModule,
    TableModule,
    PaginatorModule,
    CalendarModule,
    PanelModule,
    ProgressSpinnerModule
  ],
  providers: [{
    provide: HTTP_INTERCEPTORS,
    useClass: TokenInterceptor,
    multi: true
  },
    CustomService, AuthGuard, AuthService, DatePipe, BnNgIdleService ],
  bootstrap: [AppComponent]
})
export class AppModule { }
